import Rewind30 from './Rewind30'

export default Rewind30
// eslint-disable-next-line import/export
export * from './Rewind30'
